import React, { useState } from 'react';
import Center from "../App/Center"
import Cabins from "../Cruise/Cabins"
import Booking from "../Cruise/Booking"

export default function BookingForm( props ) {
	
	const cruise = props.cruise

	//const [ contact, setContact ] = useState( 1 );

	const [ formValues, setFormValues ] = useState( {
		name:'',
		email:'',
		phone:'',
		notes:'',
	} );

	const [ tmp, setTmp ] = useState( 0 ) 

	const [ cabins, setCabins ] = useState( { 
		cabin_master:'f',
		cabin_vip:'f',
		cabin_standard:'f',
		cabin_bunk:'f',
	} )

	const [ total, setTotal ] = useState( 0 )

	function handleChange( evt ) {
		const value = evt.target.value;
		setFormValues({
		  ...formValues,
		  [ evt.target.name ]: value
		});
	}

    const commonProps = { props, cruise, formValues, setFormValues, cabins, setCabins, tmp, setTmp, handleChange, total, setTotal }

	return <Center>
		<div className="two left" style={{ alignItems:'start' }} >
            <div className="half-text">
                <h1>Choose Cabins</h1>
                <Cabins { ...commonProps } />
            </div>
            <div className="half-text">
                <h1>Make Booking</h1>
                <Booking { ...commonProps } />
            </div>
        </div>
    </Center>
}
